import {
  EMAIL_REPLY_FORM_HTML_BLOCK_ID,
  EMAIL_REPLY_FORM_HTML_QUOTED_HISTORY_CLASSNAME,
} from '../../../constants/email'
import { EMAIL_REPLY_FORM_WYSIWYG_CLASSNAME_HIDE_QUOTED_HISTORY } from '../Email.constants'

export function getMessageFieldContentStyle() {
  return {
    contentStyles: {
      commonStyles: `.${EMAIL_REPLY_FORM_WYSIWYG_CLASSNAME_HIDE_QUOTED_HISTORY} #${EMAIL_REPLY_FORM_HTML_BLOCK_ID}.${EMAIL_REPLY_FORM_HTML_QUOTED_HISTORY_CLASSNAME} { display: none; }`,
    },
  }
}
